'use strict';

const currencies = [
    {
        name: "United States Dollars (USD)",
        code: "USD",
        sign: "$"
    }, {
        name: "Australian Dollars (AUD)",
        code: "AUD",
        sign: "$"
    }, {
        name: "Canadian Dollars (CAD)",
        code: "CAD",
        sign: "$"
    }, {
        name: "Euro (EUR)",
        code: "EUR",
        sign: "€"
    }, {
        name: "Singapore Dollar (SGD)",
        code: "SGD",
        sign: "S$"
    }, {
        name: "Pound Sterling (GBP)",
        code: "GBP",
        sign: "£"
    }, {
        name: "Other (No Symbol)",
        code: "OTR",
        sign: ""
    }
];

class Currency {
    currencyNameList: Array<string>
    signLookUp: {[code:string]: string}
    nameLookUp: {[code:string]: string}
    codeLookUp: {[name:string]: string}

    constructor() {
        this.currencyNameList = currencies.map(currency => currency.name);

        this.signLookUp = {};
        currencies.forEach(currency => this.signLookUp[currency.code] = currency.sign);

        this.nameLookUp = {};
        currencies.forEach(currency => this.nameLookUp[currency.code] = currency.name);

        this.codeLookUp = {};
        currencies.forEach(currency => this.codeLookUp[currency.name] = currency.code);
    }

    getSign(key:string) {
        if (key) {
            key = key.toUpperCase();
        }
        return this.signLookUp[key] || '';
    }

    getName(key:string) {
        if (key) {
            key = key.toUpperCase();
        }
        return this.nameLookUp[key] || 'United States Dollars (USD)';
    }

    getCode(key:string) {
        return this.codeLookUp[key] || 'USD';
    }
}

export const currency = new Currency();



// WEBPACK FOOTER //
// ./_src/services/constants/currency.ts